import React, { Fragment } from 'react'
import { Paragraph, FlagIcon, CalendarIcon, ClockIcon, GolfBallIcon, GlobeIcon, UserIcon, EntryFeeIcon } from '@pga/pga-component-library'
import { formatDate } from '../utils'

export const LocationRow = ({ hit }) => (
  <Fragment>
    { hit.location_name &&
      <Paragraph size='sm'>{hit.location_name}</Paragraph> }
    { hit.address &&
      <Paragraph size='sm'>{hit.address}</Paragraph> }
    { hit.city && hit.state &&
      <Paragraph size='sm'>{hit.city}, {hit.state} {hit.zip_code_number}</Paragraph> }
  </Fragment>
)

export const StartDate = ({ hit }) => (
  <Paragraph size='sm'>{formatDate(hit.start_datetime)}</Paragraph>
)

export const EndDate = ({ hit }) => (
  <Paragraph size='sm'>{formatDate(hit.end_datetime)}</Paragraph>
)

export const EventType = ({ hit }) => <Paragraph size='sm'>{hit.pga_event_type}</Paragraph>

export const Section = ({ hit }) => <Paragraph size='sm'>{hit.section}</Paragraph>

export const EligibleToPlay = ({ hit }) => <Paragraph size='sm'>{hit.eligible_to_play && hit.eligible_to_play.join(', ')}</Paragraph>

export const Deadline = ({ hit }) => (
  <Paragraph size='sm'>{formatDate(hit.deadline_datetime)}</Paragraph>
)

export const EventWebsite = ({ hit }) => <a href={hit.website_url} target='_blank' rel='noopener noreferrer'>Event Website</a>

export const EntryFee = ({ hit }) => <Paragraph size='sm'>${hit.entry_fee_number}</Paragraph>

export default [
  {
    Icon: FlagIcon,
    header: 'LOCATION',
    DetailComponent: LocationRow,
    field: 'location_name'
  },
  [
    {
      Icon: CalendarIcon,
      header: 'START DATE',
      DetailComponent: StartDate,
      field: 'start_datetime'
    },
    {
      header: 'END DATE',
      DetailComponent: EndDate,
      field: 'end_datetime'
    }
  ],
  [
    {
      Icon: GolfBallIcon,
      header: 'EVENT TYPE',
      DetailComponent: EventType,
      field: 'pga_event_type'
    },
    {
      header: 'SECTION',
      DetailComponent: Section,
      field: 'section'
    }
  ],
  {
    Icon: UserIcon,
    header: 'ELIGIBLE TO PLAY',
    DetailComponent: EligibleToPlay,
    field: 'eligible_to_play'
  },
  {
    Icon: EntryFeeIcon,
    header: 'ENTRY FEE',
    DetailComponent: EntryFee,
    field: 'entry_fee_number'
  },
  {
    Icon: ClockIcon,
    header: 'DEADLINE',
    DetailComponent: Deadline,
    field: 'deadline_datetime'
  },
  {
    Icon: GlobeIcon,
    header: '',
    DetailComponent: EventWebsite,
    field: 'website_url'
  }
]
